export const categories = [
  {
    id: "culture",
    name: "文化",
    description: "从艺术、历史到文学与传统文化，带你走进有温度的人文世界，读懂时代背后的文化脉络。",
    icon: "ri-book-open-line",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20elegant%20traditional%20chinese%20culture%20scene%20with%20ancient%20books%20calligraphy%20brush%20and%20ceramic%20vase%20on%20a%20wooden%20desk%2C%20soft%20natural%20light%2C%20warm%20orange%20tone%2C%20editorial%20photography%2C%20clean%20minimal%20background%2C%20high%20detail&width=800&height=600&seq=cat-culture-01&orientation=landscape",
    subcategories: [
      { id: "art", name: "艺术" },
      { id: "history", name: "历史" },
      { id: "literature", name: "文学" },
      { id: "tradition", name: "传统" },
    ],
  },
  {
    id: "entertainment",
    name: "娱乐",
    description: "影视、音乐、综艺与明星动态一网打尽，第一时间掌握正在发生的话题与热度。",
    icon: "ri-film-line",
    cover:
      "https://readdy.ai/api/search-image?query=modern%20cinema%20and%20music%20stage%20concept%20with%20stage%20lights%20microphone%20and%20film%20reel%2C%20warm%20amber%20and%20red%20toned%20lighting%2C%20creative%20editorial%20photography%2C%20clean%20dark%20minimal%20background%2C%20high%20detail&width=800&height=600&seq=cat-entertainment-01&orientation=landscape",
    subcategories: [
      { id: "movie", name: "影视" },
      { id: "music", name: "音乐" },
      { id: "star", name: "明星" },
      { id: "variety", name: "综艺" },
    ],
  },
  {
    id: "life",
    name: "生活",
    description: "美食、旅行、健康与家居实用指南，用真实经验帮你把日常过得更舒服、更有质感。",
    icon: "ri-plant-line",
    cover:
      "https://readdy.ai/api/search-image?query=bright%20cozy%20everyday%20life%20scene%20with%20coffee%20cup%20green%20plants%20and%20travel%20map%20on%20a%20sunny%20table%2C%20soft%20warm%20natural%20light%2C%20clean%20minimal%20background%2C%20editorial%20lifestyle%20photography%2C%20high%20detail&width=800&height=600&seq=cat-life-01&orientation=landscape",
    subcategories: [
      { id: "food", name: "美食" },
      { id: "travel", name: "旅行" },
      { id: "health", name: "健康" },
      { id: "home", name: "家居" },
    ],
  },
];